import { getDefaultMargin, getDefaultTypography, getDefaultWidthOverlay } from '../utils'

export const PieCharDesignSettings = {
  'pie-chart-design-width': {
    phone: ['100%'],
    'phone-landscape': ['100%'],
    tablet: ['100%'],
    'tablet-landscape': ['50%'],
    desktop: ['50%'],
    tv: ['50%'],
    overflowSetting: getDefaultWidthOverlay,
  },
  // Alignment
  'pie-chart-design-alignment': {
    phone: 'parent',
    'phone-landscape': 'parent',
    tablet: 'parent',
    'tablet-landscape': 'parent',
    desktop: 'parent',
    tv: 'parent',
  },
  'pie-chart-design-heading-alignment': {
    phone: 'center',
    'phone-landscape': 'center',
    tablet: 'center',
    'tablet-landscape': 'center',
    desktop: 'center',
    tv: 'center',
  },
  // Margin
  'pie-chart-design-heading-margin': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  'pie-chart-design-component-margin': {
    phone: getDefaultMargin([16]),
    'phone-landscape': getDefaultMargin([16]),
    tablet: getDefaultMargin([16]),
    'tablet-landscape': getDefaultMargin([16]),
    desktop: getDefaultMargin([16]),
    tv: getDefaultMargin([16]),
  },
  // Typography
  'pie-chart-design-typography': {
    phone: getDefaultTypography('Body Large'),
    'phone-landscape': getDefaultTypography('Body Large'),
    tablet: getDefaultTypography('Body Large'),
    'tablet-landscape': getDefaultTypography('Body Large'),
    desktop: getDefaultTypography('Body Large'),
    tv: getDefaultTypography('Body Large'),
  },
  'pie-chart-design-heading-typography': {
    phone: getDefaultTypography('headline-small'),
    'phone-landscape': getDefaultTypography('headline-small'),
    tablet: getDefaultTypography('headline-small'),
    'tablet-landscape': getDefaultTypography('headline-small'),
    desktop: getDefaultTypography('headline-small'),
    tv: getDefaultTypography('headline-small'),
  },
}
